import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { STATE_LAW_API } from "./apiRoutes";

const mutateAddStateLaw = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${STATE_LAW_API}`, data);
};

const useAddStateLawMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddStateLaw,
    ...queryParams,
  });

export default useAddStateLawMutation;
